// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__1znrv","footer":"Layout_footer__R95cA","footerContainer":"Layout_footerContainer__1aF8L"};